<script setup lang="ts">
interface Props {
  name: string
  important?: boolean
  isFulfilled?: boolean
}

defineProps<Props>()
</script>

<template>
  <div
    class="-space-y-1 pb-2 text-center"
    :class="{
      'text-red-700': important && !isFulfilled,
    }"
  >
    <div
      class="font-bold"
      :class="[important && !isFulfilled && `after:content-['*']`]"
    >
      {{ name }}
    </div>
    <div class="h-3 text-xs">
      {{ important && !isFulfilled ? 'Not added' : '' }}
    </div>
  </div>
</template>
